import collapseExpand from './collapseExpand.vue'
export default collapseExpand
